export function bindHeaderControls({
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onNowToggle,
  onDateInput,
  onTodayDate,
  onPreviousDate,
  onNextDate,
}) {
  const zoomInBtn = document.getElementById('zoomIn');
  const zoomOutBtn = document.getElementById('zoomOut');
  const zoomLevelBtn = document.getElementById('zoomLevel')
    || document.getElementById('zoomLevelHeader')
    || document.getElementById('zoomLabel');

  const nowToggleBtn = document.getElementById('nowButton');
  const dateInput = document.getElementById('timelineDatePicker');
  const todayBtn = document.getElementById('timelineDateToday');
  const previousDateBtn = document.getElementById('timelineDatePrevious');
  const nextDateBtn = document.getElementById('timelineDateNext');

  const handlers = [];

  function wire(btn, eventName, fn) {
    if (!btn || typeof fn !== 'function') return;
    btn.addEventListener(eventName, fn);
    handlers.push(() => btn.removeEventListener(eventName, fn));
  }

  wire(zoomInBtn, 'click', onZoomIn);
  wire(zoomOutBtn, 'click', onZoomOut);
  wire(zoomLevelBtn, 'click', onZoomReset);
  wire(nowToggleBtn, 'click', onNowToggle);
  wire(todayBtn, 'click', onTodayDate);
  wire(previousDateBtn, 'click', onPreviousDate);
  wire(nextDateBtn, 'click', onNextDate);

  if (dateInput && typeof onDateInput === 'function') {
    const fn = () => onDateInput(dateInput.value);
    dateInput.addEventListener('change', fn);
    handlers.push(() => dateInput.removeEventListener('change', fn));
  }

  return () => handlers.forEach((off) => off());
}
